import * as React from "react";
import { cn } from "~/lib/utils";

export type TextAreaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    invalid?: boolean;
  };

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, disabled, invalid, ...rest }, ref) => {
    const classNames = cn("fui-text-area__input", className);
    return (
      <div
        className={cn(
          "fui-text-area",
          {
            "fui-text-area--disabled": disabled,
            "fui-text-area--invalid": invalid,
          },
          className,
        )}
      >
        <textarea
          disabled={disabled}
          className={classNames}
          ref={ref}
          {...rest}
        />
      </div>
    );
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
